import Axios from 'axios';
import { action, observable, computed } from 'mobx';
import { OrderParams, PageInfo, ScrollPageInfo } from '@/models/data';
import { Notification } from 'element-react';
import { API } from '@/config/api';
import i18n from '@/i18n';
import { getBaseUrlBySymbol, getBaseUrlByUnderlyingType } from '@/utils/futures';
import UnderLyingEnum from '@/@enums/UnderLyingEnum';
import { message } from 'antd';

export interface OrderItem {
  avgPrice: string; //	成交均价
  closePosition: boolean; //	是否条件全平仓
  createdTime: number; //	创建时间
  sourceId: string; //	条件触发id
  executedQty: string; //	已成交数量
  marginFrozen: string; //	占用保证金
  orderId: string; //	订单id
  orderSide: OrderSide; //	买卖方向
  orderType: string; //	订单类型
  origQty: string; // 	数量
  positionSide: PositionSide; // 	持仓方向
  price: string; //	委托价格
  state: OrderState; //	订单状态 1：新建订单（未成交）；2：部分成交；3：全部成交；4：已撤销；5：平台撤销（拒绝）；6：已过期
  symbol: string; //	交易对
  timeInForce: string; // 有效类型
  closeProfit: string; // 平仓盈亏

  // 其他配置
  contractSize: string;
}

export interface OrderBillItem {
  fee: number;
  feeCoin: string;
  orderId: number;
  price: number;
  quantity: number;
  symbol: string;
  timestamp: number;
}

export interface RegularDetailItem {
  id: string | number;
  img: string;
  name: string;
  coinType: string;
  yearChemicalRate: string;
  subscriptionPeriod: string | number;
  coinAmount: string; // 单次最小申购额度
  useAmount: string; // 单次最大申购额度
  limitAmount: string; // 申购限额 最大
  surplusQuantity: string; //
  shareValue: string; // 最小可投shareValue 最小申购限额
  maxValue: string; // 最大可投maxvalue
}

export interface ProductList {
  coinType: string;
  img: string;
  productList: RegularDetailItem[];
}
export interface ProfitList {
  userProfitDay: number; // 用户总昨日收益
  userProfit: number; // 用户累计总收益
  userFroze: number; // 资产折合
  userFrozeVO: {
    // 用户资产分布
    cloudFroze: string; //	云算力收益
    currentFroze: string; // 活期宝收益
    defiFroze: string; // defi收益
    financialFroze: string; // 定期宝收益
    posFroze: string; // pos锁仓收益
    purchaseFroze: string; // 抢购收益
    userAmount: string; // 可用
  };
  userProfitDayVO: {
    //	用户昨日收益
    cloudAmount: string; //	云算力收益
    currentAmount: string; // 活期宝收益
    defiAmount: string; // defi收益
    financialAmount: string; // 定期宝收益
    posAmount: string; // pos锁仓收益
    purchaseAmount: string; // 抢购收益
  };
  userProfitVO: {
    // 用户总收益
    cloudAmount: string; //	云算力收益
    currentAmount: string; // 活期宝收益
    defiAmount: string; // defi收益
    financialAmount: string; // 定期宝收益
    posAmount: string; // pos锁仓收益
    purchaseAmount: string; // 抢购收益
  };
}
export interface AssetSummary {
  equivalentAvailableBalance: string | number;

  equivalentCoinName: string | number;
  equivalentProfitTotal: string | number;
}
export interface CurrentList {
  autoIn: boolean; // 自动转入
  coinType: string; //
  id: number; //
  img: string; //
  limitAmount: string; // 认购限额
  maxAmount: string; // 最大可投金额
  minAmount: string; // 起投金额
  rate: string; //	七日年化收益
  referIncome: string; // 千份参考收益
  surplusQuantity: string; // 剩余额度
  tagList: []; // 标签列表
}

export interface CurrentDetail {
  coinType: string; //
  img: string; //
  useAmount: string; // 已认购数量
  limitAmount: string; // 认购限额
  maxAmount: string; // 最大可投金额
  minAmount: string; // 起投金额
  rate: string; //	参考年化收益
  surplusQuantity: string; // 剩余额度
  interestCycle: number; // 发息周期
  scale: number; // 精度
}
export interface ProductOrderList {
  coinType: string; //
  img: string; //
  income: string; // 累计总收益
  nameLangCode: string; // 产品名国际化
  productId: number; // 产品id
  productName: string; // 产品名称
  subscriptionPeriod: number; // 锁仓期限
  totalAmount: string; // 购买总数量
  yearChemicalRate: string; // 年化率 百分之
  yesterdayInterest: string; // 昨日收益
}
export interface ProductOrderBuyList {
  buyDate: string; // 购买日期
  coinType: string; //
  createTime: number; // 创建时间
  expiresDate: number; // 	到期时间
  orderId: string; // 订单id
  orderStatus: number; // 订单状态
  productName: string; // 产品名称
  remainingDays: number; // 剩余天数
  subscriptionPeriod: number; // 锁仓期限
  totalShareValue: string; // 数量
  type: number; // 订单类型 1-存入 2-取出
  yearChemicalRate: string; // 年化率 百分之
}
export interface ProductIncomeList {
  coinType: string; //
  createTime: number; // 发放
  income: number; // 	发放收益
  status: string; // 发放状态
  totalShareValue: number; // 存币金额
  yearChemicalRate: string; // 年化率 百分之
}

export interface CurrentOrderList {
  autoIn: boolean; // 自动转入
  img: string; // 自动转入

  coinType: string; //
  income: string; // 累计总收益
  totalAmount: string; // 	购买总数量
  yearChemicalRate: string; // 年化率 百分之
  yesterdayInterest: string; // 昨日收益
}
export interface CurrentOrderBuyList {
  buyAmount: string; // 	购买数量
  coinType: string; // 自动转入
  createTime: number; // 提交时间
  nextIncome: string; // 预计下次收益
  orderId: string; //
  orderStatus: number; // 订单状态
  type: number; // 类型 1-存入 2-取出
  yearChemicalRate: string; // 预期年化收益
}

export interface CurrentIncomeList {
  coinType: string; //
  createTime: number; // 发放时间
  currentAmount: string; // 存币金额
  interestAmount: string; // 	发放收益
  status: number; // 发放状态
  yearChemicalRate: string; // 预期年化收益
}
export interface PledgeDetailList {
  coinType: string; //
  img: string; //
  lockAmount: string; // 计息中
  todayAmount: string; // 今日申购
  todayRedeem: string; // 	今日赎回
  totalAmount: string; // 总金额
  totalIncome: string; // 	累计收益
}
export interface FlowList {
  coinType: string; //
  img: string; //
  lockAmount: string; // 计息中
  todayAmount: string; // 今日申购
  todayRedeem: string; // 	今日赎回
  totalAmount: string; // 总金额
  totalIncome: string; // 	累计收益
}
export default class Fiannce {
  @observable productList: ProductList[];

  @observable currentList: CurrentList[];

  @observable profitList: ProfitList;

  @observable regularDetail: RegularDetailItem[];

  @observable assetSummary: AssetSummary;

  @observable productListPageInfo: PageInfo; // 定期fixedSavings

  @observable currentListPageInfo: PageInfo; // 定期fixedSavings

  @observable productListOrderPageInfo: PageInfo; // 定期fixedSavings

  @observable productBuyListOrderPageInfo: PageInfo; //

  @observable currentOrderListPageInfo: PageInfo; //

  @observable currentOrderBuyListPageInfo: PageInfo; //

  @observable currentIncomeListPageInfo: PageInfo; //

  @observable productIncomePageInfo: PageInfo; //

  @observable flowListPageInfo: PageInfo; //

  @observable isFetchingCurrentList: boolean;

  @observable isFetchingProductList: boolean;

  @observable isFetchingOrderBillList: boolean;

  @observable isFetchingLiquidationRecord: boolean;

  @observable isCanBuy: boolean; // 是否可购买

  @observable currentDetail: CurrentDetail; // 活期宝详情

  @observable productOrderList: ProductOrderList[]; // 定期宝订单列表

  @observable productOrderBuyList: ProductOrderBuyList[]; // 定期宝购买记录 订单

  @observable productIncomeList: ProductIncomeList[]; // 定期宝购买记录 订单

  @observable currentOrderList: CurrentOrderList[]; // 活期宝订单列表

  @observable currentOrderBuyList: CurrentOrderBuyList[]; // 活期宝 订单

  @observable currentIncomeList: CurrentIncomeList[]; // 活期宝 收益

  @observable pledgeDetailList: PledgeDetailList; // 活期宝 质押详情 currentPledgeDetailList

  @observable flowList: FlowList[]; // 资金流水

  @observable isFetchingProductOrderList: boolean; //

  @observable isFetchingProductOrderBuyList: boolean; //

  @observable isFetchingProductIncomeList: boolean; //

  @observable isFetchingCurrentOrderBuyList: boolean; //

  @observable isFetchingCurrentIncomeList: boolean; //

  @observable isFetchingCurrentOrderList: boolean; //

  @observable isFetchingFlowList: boolean; //

  @observable flowTypes: any[]; //

  constructor() {
    this.currentDetail = {
      coinType: '',
      img: '',
      interestCycle: 1,
      limitAmount: '0',
      maxAmount: '0',
      minAmount: '0',
      rate: '0',
      scale: 2,
      surplusQuantity: '0',
      useAmount: '0',
    };

    this.currentList = [];
    this.assetSummary = {
      equivalentAvailableBalance: 0, // 、、总资产
      equivalentCoinName: 0,
      equivalentProfitTotal: 0, // 累计收益
    };
    this.profitList = {
      userProfit: 0,
      userProfitDay: 0,
      userFroze: 0,
      userFrozeVO: {
        cloudFroze: '', //	云算力收益
        currentFroze: '', // 活期宝收益
        defiFroze: '', // defi收益
        financialFroze: '', // 定期宝收益
        posFroze: '', // pos锁仓收益
        purchaseFroze: '', // 抢购收益
        userAmount: '', // 可用
      },
      userProfitDayVO: {
        cloudAmount: '', //	云算力收益
        currentAmount: '', // 活期宝收益
        defiAmount: '', // defi收益
        financialAmount: '', // 定期宝收益
        posAmount: '', // pos锁仓收益
        purchaseAmount: '', // 抢购收益
      },
      userProfitVO: {
        cloudAmount: '', //	云算力收益
        currentAmount: '', // 活期宝收益
        defiAmount: '', // defi收益
        financialAmount: '', // 定期宝收益
        posAmount: '', // pos锁仓收益
        purchaseAmount: '', // 抢购收益
      },
    };
    this.productList = [];
    this.regularDetail = [];
    this.productListPageInfo = {
      page: 1,
      size: 10,
      total: 0,
    };
    this.currentListPageInfo = {
      page: 1,
      size: 10,
      total: 0,
    };
    this.isFetchingProductList = false;
    this.isFetchingCurrentList = false;
    this.isFetchingOrderBillList = false;
    this.isFetchingLiquidationRecord = false;
    this.isCanBuy = false;
    this.productOrderList = [];
    this.isFetchingProductOrderList = false;
    this.productListOrderPageInfo = {
      page: 1,
      size: 10,
      total: 0,
    };
    this.isFetchingProductOrderBuyList = false;

    this.productOrderBuyList = [];

    this.productBuyListOrderPageInfo = {
      page: 1,
      size: 10,
      total: 0,
    };
    this.productIncomeList = [];

    this.productIncomePageInfo = {
      page: 1,
      size: 10,
      total: 0,
    };
    this.isFetchingProductIncomeList = false;
    this.currentOrderList = [];
    this.currentOrderListPageInfo = {
      page: 1,
      size: 10,
      total: 0,
    };
    this.isFetchingCurrentOrderList = false;

    this.currentOrderBuyList = [];
    this.currentOrderBuyListPageInfo = {
      page: 1,
      size: 10,
      total: 0,
    };
    this.isFetchingCurrentOrderBuyList = false;

    this.currentIncomeList = [];
    this.currentIncomeListPageInfo = {
      page: 1,
      size: 10,
      total: 0,
    };
    this.isFetchingCurrentIncomeList = false;
    this.pledgeDetailList = {
      coinType: '', //
      img: '', //
      lockAmount: '', // 计息中
      todayAmount: '', // 今日申购
      todayRedeem: '', // 	今日赎回
      totalAmount: '', // 总金额
      totalIncome: '', // 	累计收益
    };

    this.isFetchingFlowList = false;

    this.flowList = [];
    this.flowListPageInfo = {
      page: 1,
      size: 10,
      total: 0,
    };
    this.flowTypes = [];
  }

  @action.bound
  setLoadingState(key: string, data: boolean) {
    // @ts-ignore
    this[key] = data;
  }

  @action
  setProductOrderBuyList(data: ProductOrderBuyList[]) {
    this.productOrderBuyList = data;
  }

  @action
  setProductList(data: ProductList[]) {
    this.productList = data;
  }

  @action
  setProductOrderList(data: ProductOrderList[]) {
    this.productOrderList = data;
  }

  @action
  setCurrentOrderList(data: CurrentOrderList[]) {
    this.currentOrderList = data;
  }

  @action
  setFlowList(data: FlowList[]) {
    this.flowList = data;
  }

  @action
  setFlowTypes(data: any[]) {
    this.flowTypes = data;
  }

  @action
  setCurrentIncomeList(data: CurrentIncomeList[]) {
    this.currentIncomeList = data;
  }

  @action
  setCurrentOrderBuyList(data: CurrentOrderBuyList[]) {
    this.currentOrderBuyList = data;
  }

  @action.bound
  setIsCanBuy(data: boolean) {
    this.isCanBuy = data;
    localStorage.setItem('isCanBuy', String(data));
  }

  @action
  setProductIncomeList(data: ProductIncomeList[]) {
    this.productIncomeList = data;
  }

  @action
  setProfitList(data: ProfitList) {
    this.profitList = data;
  }

  @action
  setAssetSummary(data: AssetSummary) {
    this.assetSummary = data;
  }

  @action
  setCurrentDetail(data: CurrentDetail) {
    this.currentDetail = data;
  }

  @action
  setRegularDetail(data: RegularDetailItem[]) {
    this.regularDetail = data;
  }

  @action
  setCurrentList(data: CurrentList[]) {
    this.currentList = data;
  }

  @action
  setPledgeDetailList(data: PledgeDetailList) {
    this.pledgeDetailList = data;
  }

  @action.bound
  setProductListPageInfo(data: PageInfo) {
    const origin = { ...this.productListPageInfo };
    this.productListPageInfo = { ...origin, ...data };
  }

  @action.bound
  setFlowListPageInfo(data: PageInfo) {
    const origin = { ...this.flowListPageInfo };
    this.flowListPageInfo = { ...origin, ...data };
  }

  @action.bound
  setCurrentListPageInfo(data: PageInfo) {
    const origin = { ...this.currentListPageInfo };
    this.currentListPageInfo = { ...origin, ...data };
  }

  @action.bound
  setProductIncomePageInfo(data: PageInfo) {
    const origin = { ...this.productIncomePageInfo };
    this.productIncomePageInfo = { ...origin, ...data };
  }

  @action.bound
  setProductOrderListPageInfo(data: PageInfo) {
    const origin = { ...this.productListOrderPageInfo };
    this.productListOrderPageInfo = { ...origin, ...data };
  }

  @action.bound
  setCurrentOrderBuyListPageInfo(data: PageInfo) {
    const origin = { ...this.currentOrderBuyListPageInfo };
    this.currentOrderBuyListPageInfo = { ...origin, ...data };
  }

  @action.bound
  setCurrentIncomeListPageInfo(data: PageInfo) {
    const origin = { ...this.currentIncomeListPageInfo };
    this.currentIncomeListPageInfo = { ...origin, ...data };
  }

  @action.bound
  setCurrentOrderListPageInfo(data: PageInfo) {
    const origin = { ...this.currentOrderListPageInfo };
    this.currentOrderListPageInfo = { ...origin, ...data };
  }

  @action.bound
  setProductOrderBuyListPageInfo(data: PageInfo) {
    const origin = { ...this.productBuyListOrderPageInfo };
    this.productBuyListOrderPageInfo = { ...origin, ...data };
  }

  // 用户资产分布
  @computed get userFrozeVO() {
    const { userFrozeVO } = this.profitList;
    return userFrozeVO;
  }

  // 用户昨日收益
  @computed get userProfitDayVO() {
    const { userProfitDayVO } = this.profitList;
    return userProfitDayVO;
  }

  //	用户总收益
  @computed get userProfitVO() {
    const { userProfitVO } = this.profitList;
    return userProfitVO;
  }

  // 定期列表
  @action.bound
  async fetchProductList(params?: { keywords?: string; page?: number; size?: number; isCanBuy?: boolean }) {
    this.setLoadingState('isFetchingProductList', true);
    const productListPageInfo = this.productListPageInfo;
    const config: any = {
      params: {
        page: productListPageInfo.page,
        size: productListPageInfo.size,
        isCanBuy: this.isCanBuy,
        ...params,
      },
    };
    const result: any = await Axios.get(API.PRODUCT_LIST, config);
    if (result) {
      const { data, pageRequest, total } = result;
      const { page, size } = pageRequest;
      this.setProductList(data);
      this.setProductListPageInfo({ page, size, total });
    }
    this.setLoadingState('isFetchingProductList', false);
  }

  // 定期购买
  @action.bound
  async fetchProductPurchase(data) {
    const result: any = await Axios.post(API.PRODUCT_PURCHASE, data).catch(({ error }: any) => {
      message.error(error);
    });
    if (result) {
      message.success('购买成功');
      return Promise.resolve(result);
    }
  }

  // 定期详情
  @action.bound
  async fetchRegularDetail(params) {
    // this.setLoadingState('isFetchingProductList', true);

    const result: any = await Axios.get(API.PRODUCT_DETAIL, { params });
    if (result) {
      this.setRegularDetail(result);
    }
    // this.setLoadingState('isFetchingProductList', false);
  }

  // h活期列表
  @action.bound
  async fetchCurrentList(params?: { keywords?: string; page?: number; size?: number; isCanBuy?: boolean }) {
    this.setLoadingState('isFetchingCurrentList', true);
    const currentListPageInfo = this.currentListPageInfo;
    const config: any = {
      params: {
        page: currentListPageInfo.page,
        size: currentListPageInfo.size,
        isCanBuy: this.isCanBuy,

        ...params,
      },
    };
    const result: any = await Axios.get(API.CURRENT_LIST, config);
    if (result) {
      const { data, pageRequest, total } = result;
      const { page, size } = pageRequest;
      this.setCurrentList(data);
      this.setCurrentListPageInfo({ page, size, total });
    }
    this.setLoadingState('isFetchingCurrentList', false);
  }

  // 排行榜列表
  @action.bound
  async fetchRankList() {
    // this.setLoadingState('isFetchingProductList', true);

    const result: any = await Axios.get(API.RANK_LIST);
    if (result) {
      this.setRegularDetail(result);
    }
    // this.setLoadingState('isFetchingProductList', false);
  }

  // 收益
  @action.bound
  async fetchProfitList() {
    // this.setLoadingState('isFetchingProductList', true);

    const result: any = await Axios.get(API.PROFIT_LIST);
    if (result) {
      this.setProfitList(result);
    }
    // this.setLoadingState('isFetchingProductList', false);
  }

  // 理财总资金，累计收益
  @action.bound
  async fetchAssetSummary(params) {
    // this.setLoadingState('isFetchingProductList', true);

    const result: any = await Axios.get(API.AEEST_SUMMARY, { params });
    if (result) {
      this.setAssetSummary(result);
    }
    // this.setLoadingState('isFetchingProductList', false);
  }

  // 活期宝自动转入
  @action.bound
  async fetchSetSwitch(data) {
    const result: any = await Axios.post(API.SET_SWITCH, data).catch(({ error }: any) => {
      message.error(error);
    });
    if (result) {
      return Promise.resolve(result);
    }
  }

  // 活期宝转入
  @action.bound
  async fetchCurrentIn(data) {
    const result: any = await Axios.post(API.CURRENT_IN, data).catch(({ error }: any) => {
      message.error(error);
    });
    if (result) {
      this.fetchCurrentList();
      message.success('转入成功');

      return Promise.resolve(result);
    }
  }

  // 活期宝赎回
  @action.bound
  async fetchCurrentOut(data) {
    const result: any = await Axios.post(API.CURRENT_OUT, data).catch(({ error }: any) => {
      message.error(error);
    });
    if (result) {
      this.fetchCurrentList();
      message.success('赎回成功');

      return Promise.resolve(result);
    }
  }

  // 活期宝详情
  @action.bound
  async fetchCurrentDetail(params) {
    const result: any = await Axios.get(API.CURRENT_DETAIL, { params }).catch(({ error }: any) => {
      message.error(error);
    });
    if (result) {
      this.setCurrentDetail(result);

      return Promise.resolve(result);
    }
  }

  // 定期宝订单列表

  @action.bound
  async fetchProductOrderList(params?: { coinType?: string; page?: number; size?: number }) {
    this.setLoadingState('isFetchingProductOrderList', true);
    const productListPageInfo = this.productListOrderPageInfo;
    const config: any = {
      params: {
        page: productListPageInfo.page,
        size: productListPageInfo.size,

        ...params,
      },
    };
    const result: any = await Axios.get(API.PRODUCT_ORDER_LIST, config);
    if (result) {
      const { data, pageRequest, total } = result;
      const { page, size } = pageRequest;
      this.setProductOrderList(data);
      this.setProductOrderListPageInfo({ page, size, total });
    }
    this.setLoadingState('isFetchingProductOrderList', false);
  }

  // 定期宝购买记录 订单
  @action.bound
  async fetchProductOrderBuyList(params?: {
    page?: number;
    size?: number;
    productId: number;
    from?: number;
    to?: number;
  }) {
    this.setLoadingState('isFetchingProductOrderBuyList', true);
    const productBuyListOrderPageInfo = this.productBuyListOrderPageInfo;
    const config: any = {
      params: {
        page: productBuyListOrderPageInfo.page,
        size: productBuyListOrderPageInfo.size,

        ...params,
      },
    };
    const result: any = await Axios.get(API.PRODUCT_BUY_LIST, config);
    if (result) {
      const { data, pageRequest, total } = result;
      const { page, size } = pageRequest;
      this.setProductOrderBuyList(data);
      this.setProductOrderBuyListPageInfo({ page, size, total });
    }
    this.setLoadingState('isFetchingProductOrderBuyList', false);
  }

  // 定期宝订单收益
  @action.bound
  async fetchProductIncomeList(params?: { page?: number; size?: number; productId: number }) {
    this.setLoadingState('isFetchingProductIncomeList', true);
    const productIncomePageInfo = this.productIncomePageInfo;
    const config: any = {
      params: {
        page: productIncomePageInfo.page,
        size: productIncomePageInfo.size,

        ...params,
      },
    };
    const result: any = await Axios.get(API.PRODUCT_INCOME_LIST, config);
    if (result) {
      const { data, pageRequest, total } = result;
      const { page, size } = pageRequest;
      this.setProductIncomeList(data);
      this.setProductIncomePageInfo({ page, size, total });
    }
    this.setLoadingState('isFetchingProductIncomeList', false);
  }

  // 活期宝 订单列表
  @action.bound
  async fetchCurrentOrderList(params?: {
    page?: number;
    size?: number;
    productId: number;
    from?: number;
    to?: number;
  }) {
    this.setLoadingState('isFetchingCurrentOrderList', true);
    const currentOrderListPageInfo = this.currentOrderListPageInfo;
    const config: any = {
      params: {
        page: currentOrderListPageInfo.page,
        size: currentOrderListPageInfo.size,

        ...params,
      },
    };
    const result: any = await Axios.get(API.CURRENT_ORDER_LIST, config);
    if (result) {
      const { data, pageRequest, total } = result;
      const { page, size } = pageRequest;
      this.setCurrentOrderList(data);
      this.setCurrentOrderListPageInfo({ page, size, total });
    }
    this.setLoadingState('isFetchingCurrentOrderList', false);
  }

  //  活期宝 收益
  @action.bound
  async fetchCurrentIncomeList(params?: {
    page?: number;
    size?: number;
    coinType: string;
    from?: number;
    to?: number;
  }) {
    this.setLoadingState('isFetchingCurrentIncomeList', true);
    const currentIncomeListPageInfo = this.currentIncomeListPageInfo;
    const config: any = {
      params: {
        page: currentIncomeListPageInfo.page,
        size: currentIncomeListPageInfo.size,

        ...params,
      },
    };
    const result: any = await Axios.get(API.CURRENT_INCOME, config);
    if (result) {
      const { data, pageRequest, total } = result;
      const { page, size } = pageRequest;
      this.setCurrentIncomeList(data);
      this.setCurrentIncomeListPageInfo({ page, size, total });
    }
    this.setLoadingState('isFetchingCurrentIncomeList', false);
  }

  //  活期宝 存取记录 订单
  @action.bound
  async fetchCurrentOrderBuyList(params?: {
    page?: number;
    size?: number;
    coinType: string;
    from?: number;
    to?: number;
  }) {
    this.setLoadingState('isFetchingCurrentOrderBuyList', true);
    const currentOrderBuyListPageInfo = this.currentOrderBuyListPageInfo;
    const config: any = {
      params: {
        page: currentOrderBuyListPageInfo.page,
        size: currentOrderBuyListPageInfo.size,
        ...params,
      },
    };
    const result: any = await Axios.get(API.CURRENT_IO_LIST, config);
    if (result) {
      const { data, pageRequest, total } = result;
      const { page, size } = pageRequest;
      this.setCurrentOrderBuyList(data);
      this.setCurrentOrderBuyListPageInfo({ page, size, total });
    }
    this.setLoadingState('isFetchingCurrentOrderBuyList', false);
  }

  //  活期宝质押详情 赎回弹窗
  @action.bound
  async fetchPledgeDetailList(params?: { coinType: string }) {
    const result: any = await Axios.get(API.CURRENT_PLEDGE_DETAIL, { params });
    if (result) {
      this.setPledgeDetailList(result);
    }
  }

  //  资金流水
  @action.bound
  async fetchFlowList(params?: { page?: number; size?: number; type?: string; from?: number; to?: number }) {
    this.setLoadingState('isFetchingFlowList', true);
    const flowListPageInfo = this.flowListPageInfo;
    const config: any = {
      params: {
        page: flowListPageInfo.page,
        size: flowListPageInfo.size,
        ...params,
      },
    };
    const result: any = await Axios.get(API.FLOW_LIST, config);
    if (result) {
      const { data, pageRequest, total } = result;
      const { page, size } = pageRequest;
      this.setFlowList(data);
      this.setFlowListPageInfo({ page, size, total });
    }
    this.setLoadingState('isFetchingFlowList', false);
  }

  //  资金流水类型
  @action.bound
  async fetchFlowType() {
    const result: any = await Axios.get(API.TYPE_LIST);
    if (result) {
      this.setFlowTypes(result);
    }
  }
}
